import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './LanguageSwitcher.style';

import { Button, Menu, MenuItem } from '@material-ui/core';
import { GlobeNetworkIcon } from 'evergreen-ui';
import withMediaQuery from "../../../hoc/MediaQuery/withMediaQuery";

function LanguageSwitcher(props) {
    const { isTabletAndMobileSize } = props;

    const languages = {
        'nl-NL': { nativeName: isTabletAndMobileSize ? 'NL' : 'Nederlands' },
        'en-US': { nativeName: isTabletAndMobileSize ? 'EN' : 'English' },
        'fr-FR': { nativeName: isTabletAndMobileSize ? 'FR' : 'Français' },
    };
    const { i18n } = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLanguageChange = (language) => {
        i18n.changeLanguage(language);
        setAnchorEl(null);
    };

    return (
        <Container>
            <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                aria-expanded={false}
                onClick={handleClick}>
                {!isTabletAndMobileSize && <GlobeNetworkIcon size={20} />}
                {isTabletAndMobileSize && <GlobeNetworkIcon size={15} />}
                &nbsp;
                {languages[i18n.language]?.nativeName}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                disableScrollLock={true}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {Object.keys(languages).map((language) => (
                    <MenuItem
                        key={language}
                        onClick={() => handleLanguageChange(language)}
                        selected={i18n.language === language}>
                        {languages[language].nativeName}
                    </MenuItem>
                ))}
            </Menu>
        </Container>
    );
}

export default withMediaQuery(LanguageSwitcher);
